import { useEffect } from 'react';

export default function PublicPrivacidad() {
  useEffect(() => { document.title = 'Política de Privacidad · Revix.es'; }, []);

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24 text-[#1d1d1f]" data-testid="page-privacidad">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-wider text-[#6E6E73] mb-2">Legal</p>
        <h1 className="text-3xl sm:text-5xl font-bold tracking-tight">Política de Privacidad</h1>
        <p className="text-sm text-[#6E6E73] mt-3">Última actualización: mayo 2026 · RGPD + LOPDGDD</p>
      </header>

      <section className="space-y-6 text-[15px] leading-relaxed">
        <h2 className="text-xl font-semibold mt-8">1. Responsable del tratamiento</h2>
        <ul className="list-none space-y-1 pl-0">
          <li><strong>Titular:</strong> Revix.es</li>
          <li><strong>Actividad:</strong> Reparación de dispositivos electrónicos y gestión de incidencias.</li>
          <li><strong>Domicilio:</strong> España</li>
          <li><strong>Email:</strong> <a className="underline" href="mailto:privacidad@revix.es">privacidad@revix.es</a></li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">2. Finalidad del tratamiento</h2>
        <p>Tratamos tus datos personales para las siguientes finalidades:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Gestión de clientes</strong>: alta de usuario, identificación, contacto y entrega de servicios.</li>
          <li><strong>Atención de incidencias</strong>: tramitar tu solicitud de reparación, validar tu dispositivo, gestionar la logística (recogida y entrega) y emitir documentación legal.</li>
          <li><strong>Comunicaciones de servicio</strong>: enviarte avisos sobre el estado de tu reparación, presupuestos, garantías y notificaciones operativas.</li>
          <li><strong>Cumplimiento legal y contable</strong>: facturación, garantías, requerimientos de aseguradoras, contabilidad obligatoria.</li>
          <li><strong>Mejora del servicio</strong>: estadísticas anónimas y agregadas (solo si aceptas cookies analíticas).</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. Base legal del tratamiento</h2>
        <p>Tratamos tus datos sobre las siguientes bases legales (RGPD art. 6):</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Ejecución de un contrato</strong>: cuando solicitas un servicio de reparación o presupuesto.</li>
          <li><strong>Cumplimiento de una obligación legal</strong>: facturación, garantías legales, gestión fiscal.</li>
          <li><strong>Consentimiento</strong>: para envíos de comunicaciones comerciales no esenciales y para cookies no necesarias. Puedes retirarlo en cualquier momento.</li>
          <li><strong>Interés legítimo</strong>: prevención del fraude, seguridad de la plataforma y ejercicio de defensa frente a reclamaciones.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">4. Plazo de conservación</h2>
        <p>
          Conservamos tus datos durante el tiempo necesario para prestar el servicio, atender garantías
          y cumplir con las obligaciones legales aplicables (mínimo 5 años para datos contables, según
          Ley 58/2003 General Tributaria). Tras ese plazo, los datos se bloquean y posteriormente se
          suprimen.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Destinatarios de los datos (cesiones)</h2>
        <p>Sólo cedemos tus datos a terceros cuando es necesario y siempre con base legal:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Empresas de logística</strong> (GLS Spain, MRW): para gestionar la recogida y entrega de tu dispositivo. Se les facilita exclusivamente lo necesario (nombre, dirección, teléfono).</li>
          <li><strong>Aseguradoras y peritos</strong>: si tu reparación se gestiona a través de un seguro, compartimos los datos del siniestro con la aseguradora correspondiente.</li>
          <li><strong>Proveedores tecnológicos</strong>: alojamiento web (Emergent / AWS), envío de emails transaccionales (Resend), análisis estadístico (Google Analytics 4 con IP anonimizada). Todos cuentan con cláusulas de tratamiento conforme al art. 28 RGPD.</li>
          <li><strong>Administraciones públicas</strong>: cuando sea legalmente exigible (Hacienda, Fuerzas y Cuerpos de Seguridad).</li>
        </ul>
        <p>No realizamos transferencias internacionales fuera del Espacio Económico Europeo salvo que dichos proveedores ofrezcan garantías adecuadas (cláusulas contractuales tipo).</p>

        <h2 className="text-xl font-semibold mt-8">6. Tus derechos</h2>
        <p>Como titular de los datos puedes ejercer los siguientes derechos en cualquier momento:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Acceso</strong>: saber qué datos tuyos tratamos.</li>
          <li><strong>Rectificación</strong>: corregir datos inexactos o desactualizados.</li>
          <li><strong>Supresión</strong> (derecho al olvido): eliminar tus datos cuando ya no sean necesarios.</li>
          <li><strong>Oposición</strong>: oponerte al tratamiento por motivos legítimos.</li>
          <li><strong>Limitación del tratamiento</strong>: pedir que se limite mientras se resuelve una controversia.</li>
          <li><strong>Portabilidad</strong>: recibir tus datos en un formato estructurado para llevarlos a otro proveedor.</li>
          <li><strong>Retirar el consentimiento</strong> cuando lo hayas otorgado, sin afectar la licitud del tratamiento previo.</li>
          <li><strong>Reclamación ante la AEPD</strong>: <a className="underline" href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.</li>
        </ul>
        <p>
          Para ejercerlos, escríbenos a{' '}
          <a className="underline" href="mailto:privacidad@revix.es">privacidad@revix.es</a> indicando
          el derecho que deseas ejercer y adjuntando una copia de tu DNI o documento equivalente.
          Responderemos en un plazo máximo de un mes.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Seguridad de los datos</h2>
        <p>
          Aplicamos medidas técnicas y organizativas adecuadas: cifrado en tránsito (TLS 1.2+),
          almacenamiento en servidores con protección perimetral, control de accesos por roles,
          contraseñas con bcrypt, registro de eventos de seguridad y auditoría continua.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Menores de edad</h2>
        <p>
          Nuestros servicios no se dirigen a menores de 14 años. Si detectamos datos de menores sin el
          consentimiento del titular de la patria potestad, los eliminaremos.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Cambios en esta política</h2>
        <p>
          Podemos actualizar esta política para adaptarla a cambios legales o de servicio. Te avisaremos
          de cambios sustanciales por los canales habituales antes de su entrada en vigor.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. Contacto</h2>
        <p>
          Para cualquier consulta sobre privacidad escríbenos a{' '}
          <a className="underline" href="mailto:privacidad@revix.es">privacidad@revix.es</a>.
        </p>
      </section>
    </article>
  );
}
